import { PropsWithChildren } from 'react';
import { ClipPath, Defs, G, Path, Rect, Svg, SVGProps } from '@react-pdf/renderer';
interface PDFSuccessIconProps extends PropsWithChildren<SVGProps> {
  color?: string;
  size?: number;
}
const PDFSuccessIcon = ({
  size = 15,
  fill = '#FFF',
  ...props
}: PDFSuccessIconProps) => <Svg width={size} height={size} viewBox="0 0 15 15" fill={fill} color="none" {...props} data-sentry-element="Svg" data-sentry-component="PDFSuccessIcon" data-sentry-source-file="SuccessIcon.tsx">
    <G clipPath="url(#clip0_405_691)" data-sentry-element="G" data-sentry-source-file="SuccessIcon.tsx">
      <Path d="M7.5 13.75C10.9518 13.75 13.75 10.9518 13.75 7.5C13.75 4.04822 10.9518 1.25 7.5 1.25C4.04822 1.25 1.25 4.04822 1.25 7.5C1.25 10.9518 4.04822 13.75 7.5 13.75Z" stroke="#393E4D" strokeWidth="0.8" data-sentry-element="Path" data-sentry-source-file="SuccessIcon.tsx" />
      <Path d="M5.3125 7.8125L6.5625 9.0625L9.6875 5.9375" stroke="#393E4D" strokeWidth="0.8" strokeLinecap="round" strokeLinejoin="round" data-sentry-element="Path" data-sentry-source-file="SuccessIcon.tsx" />
    </G>
    <Defs data-sentry-element="Defs" data-sentry-source-file="SuccessIcon.tsx">
      <ClipPath id="clip0_405_691" data-sentry-element="ClipPath" data-sentry-source-file="SuccessIcon.tsx">
        <Rect width="15" height="15" fill="white" data-sentry-element="Rect" data-sentry-source-file="SuccessIcon.tsx" />
      </ClipPath>
    </Defs>
  </Svg>;
export default PDFSuccessIcon;